import React from 'react';
import PropTypes from 'prop-types';
import './SimpleLightBox.sass';

const SimpleLightBox = ({ images, currentIndex, onClose, onNext, onPrev }) => {
  const currentImage = images[currentIndex];
  const totalImages = images.length;

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') {
      onPrev();
    } else if (e.key === 'ArrowRight') {
      onNext();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentIndex]);

  return (
    <div className="simple-lightbox" onClick={onClose}>
      <div className="simple-lightbox__content" onClick={e => e.stopPropagation()}>
        <button className="simple-lightbox__close" onClick={onClose}>×</button>
        
        {currentIndex > 0 && (
          <button className="simple-lightbox__arrow simple-lightbox__arrow--prev" onClick={onPrev}>
            ‹
          </button>
        )}
        
        <img src={currentImage} alt={`Image ${currentIndex + 1} of ${totalImages}`} className="simple-lightbox__image" />
        
        {currentIndex < totalImages - 1 && (
          <button className="simple-lightbox__arrow simple-lightbox__arrow--next" onClick={onNext}>
            ›
          </button>
        )}
        
       
      </div>
    </div>
  );
};

SimpleLightBox.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentIndex: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
};

export default SimpleLightBox; 